import { render, staticRenderFns } from "./SettingWordListTable.vue?vue&type=template&id=27f8cfce&scoped=true"
import script from "./SettingWordListTable.vue?vue&type=script&lang=js"
export * from "./SettingWordListTable.vue?vue&type=script&lang=js"
import style0 from "./SettingWordListTable.vue?vue&type=style&index=0&id=27f8cfce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f8cfce",
  null
  
)

export default component.exports